var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.061,
    height: 14.656,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2009",
    d: "M10.817.944a.61.61 0 00-.472-.114l-1.171.293a6.282 6.282 0 01-3.627-.2h-.016A7.234 7.234 0 001.595.614l-.455.1V.568a.566.566 0 00-.569-.569.556.556 0 00-.569.569v13.519a.566.566 0 00.569.569.556.556 0 00.569-.569V8.15l.651-.13a5.973 5.973 0 013.334.277l.049.016a7.429 7.429 0 002.521.455 6.63 6.63 0 001.773-.228l1.171-.293a.571.571 0 00.423-.537V1.402a.7.7 0 00-.244-.455zm-.911 6.311l-.748.179a6.282 6.282 0 01-3.627-.2h-.016a7.429 7.429 0 00-2.521-.455 8.324 8.324 0 00-1.415.13l-.455.1V1.855l.651-.13a6.273 6.273 0 013.334.244l.049.016a7.379 7.379 0 004.278.228l.472-.114z",
    fill: "#ff005f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.f74070c922aa9b0905336da5a173d47a.svg";
export { ForwardRef as ReactComponent };